import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { deepClone } from '@/utils'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import {
  inquiryDetail,
  matchPrice,
  matchResponsiblePerson,
  saveInquiryPrice,
  submitInquiryPrice
} from '@/api/price/inquiry'
import * as ImportConstants from '@/class/cargo/model/parameters/ImportConstants'
import InquiryHp from '@/components/Cargo/Inquiry/InquiryHp'

export default {
  methods: {
    // 打印按钮触发事件
    toPrint() {
      this.templateSelectorDialog.data.INQUIRY_PRICE_UUID = this.form.uuid
      this.templateSelectorDialog.visible = true
    },
    toFileQuery() {
      this.fileHistoryHp.toFileQuery()
    },
    fileRemove() {
      const rows = this.file.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.view.$t('CargoMsg.Cargo_PleaseSelectFile'))
        return
      }
      // 删除校验 (撤销之后才能删除，撤销动作会删除报价中新增的文件，所以此处无需校验)
      // if (!this.$store.getters.isAdmin) {
      //   const row = rows.find(p => p.extendMetaData
      //       && this.$store.getters.userId !== Number(p.extendMetaData.createdBy)
      //       && p.extendMetaData.belong === SystemConstants.FILE_BELONG_QUOTATION.code)
      //   if (row) {
      //     this.$message.warning(this.$t('CargoMsg.Cargo_FileFromQuotation'))
      //     return
      //   }
      // }
      this.fileHistoryHp.fileRemove()
    },
    fileDownload() {
      this.fileHistoryHp.fileDownload()
    },
    fileSendEmail() {
      this.fileHistoryHp.fileSendEmail()
    },
    init() {
      this.convertSeaEq() // 先转换一下箱型箱量
      // 初始化时，uuid存在时查询
      if (!this.form.uuid || this.form.status === SystemConstants.INQUIRY_STATUS_DRAFT.code) {
        this.matchPriceClick()
      } else {
        this.detail()
      }
      if (this.form.uuid) {
        this.fileHistoryHp.init()
      }
    },
    convertSeaEq() {
      if (!this.form.seaEq) {
        this.form.seaEqList = []
        return
      }
      const seaEqList = []
      this.form.seaEq.split(',').forEach(value => {
        seaEqList.push({ type: value.split('*')[1], quantity: Number(value.split('*')[0]) })
      })
      this.form.seaEqList = seaEqList
    },
    initSelectedRow(rowData) {
      const list = rowData || []
      if (list.length > 0) {
        list[0].selected = true
        return list[0]
      }
      return null
    },
    detail() {
      const filter = {
        uuid: this.form.uuid,
        prePortEnable: this.form.prePortEnable,
        lastMileEnable: this.form.lastMileEnable,
        trunkLineEnable: this.form.trunkLineEnable,
        inquiryType: this.form.type
      }
      inquiryDetail(filter).then(res => {
        this.$set(this, 'quotations', (res && res.data && res.data.quotations) ? res.data.quotations : [])
        if (filter.trunkLineEnable) {
          this.trunkLineData = res.data.trunkLineData || []
          this.selectedTrunkLineData = this.initSelectedRow(this.trunkLineData)
        }
        if (filter.prePortEnable) {
          this.prePortData = res.data.prePortData || []
          this.selectedPrePortData = this.initSelectedRow(this.prePortData)
        }
        if (filter.lastMileEnable) {
          this.lastMileData = res.data.lastMileData || []
          this.selectedLastMileData = this.initSelectedRow(this.lastMileData)
        }
      })
    },

    pagination(params) {
      const filter = deepClone(this.filter)
      filter.priceTypes = params.priceTypes
      filter.pageNum = params.pageNum
      filter.pageSize = params.pageSize
      this.doMatchPrice(filter)
    },

    doMatchPrice(filter) {
      this.loading = getLoading4Cxt()
      matchPrice(filter).then(res => {
        if (filter.priceTypes.indexOf(SystemConstants.PRICE_QUOTATION_TYPE_TRUNK_LINE.code) > -1) {
          this.trunkLineData = res.data.trunkLineData ? res.data.trunkLineData.list : []
          this.trunkLineDataTotal = res.data.trunkLineData ? res.data.trunkLineData.total : 0
        }
        if (filter.priceTypes.indexOf(SystemConstants.PRICE_QUOTATION_TYPE_PRE_PORT.code) > -1) {
          this.prePortData = res.data.prePortData ? res.data.prePortData.list : []
          this.prePortDataTotal = res.data.prePortData ? res.data.prePortData.total : 0
        }
        if (filter.priceTypes.indexOf(SystemConstants.PRICE_QUOTATION_TYPE_LAST_MILE.code > -1)) {
          this.lastMileData = res.data.lastMileData ? res.data.lastMileData.list : []
          this.lastMileDataTotal = res.data.lastMileData ? res.data.lastMileData.total : 0
        }
      }).finally(() => {
        this.loading.close()
      })
    },

    fieldChange() {
      // console.log('11111')
      // // 判断条件是否都有值
      // if (!this.form.uuid) {
      //   const priceTypes = []
      //   // 港前
      //   if (this.form.prePortEnable) {
      //     // 必须存在的字段
      //     if (this.form.province && this.form.pol &&
      //         (this.form.cargoReadyTimeType === SystemConstants.CARGO_READY_TIME_TYPE_RANGE.code || this.form.cargoReadyTimeDate)) {
      //       console.log('22222')
      //       // 影响匹配的字段是否变更
      //       if (!this.lastFilter || this.lastFilter.pol !== this.form.pol ||
      //           this.lastFilter.cargoReadyTimeType !== this.form.cargoReadyTimeType ||
      //           this.lastFilter.cargoReadyTimeDate !== this.form.cargoReadyTimeDate ||
      //           this.lastFilter.province !== this.form.province ||
      //           this.lastFilter.city !== this.form.city || this.lastFilter.districts !== this.form.districts || this.lastFilter.townUuid !== this.form.townUuid) {
      //         console.log('3333')
      //         priceTypes.push(SystemConstants.PRICE_QUOTATION_TYPE_PRE_PORT.code)
      //       }
      //     }
      //   }
      //   // 尾程
      //   if (this.form.lastMileEnable) {
      //     // 必须存在的字段
      //     if (this.form.pod && (this.form.cargoReadyTimeType === SystemConstants.CARGO_READY_TIME_TYPE_RANGE.code || this.form.cargoReadyTimeDate) &&
      //     ((this.form.deliveryAddressType === SystemConstants.DELIVERY_ADDRESS_TYPE_THIRD_PARTY.code && this.form.postalCode) ||
      //             this.form.warehouseCode)) {
      //       if (!this.lastFilter || this.lastFilter.pod !== this.form.pod ||
      //           this.lastFilter.cargoReadyTimeType !== this.form.cargoReadyTimeType ||
      //           this.lastFilter.cargoReadyTimeDate !== this.form.cargoReadyTimeDate) {
      //         priceTypes.push(SystemConstants.PRICE_QUOTATION_TYPE_LAST_MILE.code)
      //       }
      //     }
      //   }
      //   // 干线
      //   if (this.form.trunkLineEnable) {
      //     if (this.type === SystemConstants.PRICE_INQUIRY_TYPE_SEA_FCL.code) {
      //       console.log('4444')
      //
      //       const seaEqTypes = this.form.seaEqList.filter(p => !!p.type).map(p => p.type).sort()
      //       // 必须存在的字段
      //       if (seaEqTypes && seaEqTypes.length > 0 && this.form.pol && this.form.pod &&
      //           (this.form.cargoReadyTimeType === SystemConstants.CARGO_READY_TIME_TYPE_RANGE.code || this.form.cargoReadyTimeDate)) {
      //         console.log('5555')
      //
      //         // 影响匹配的字段是否变更
      //         if (!this.lastFilter || this.lastFilter.pol !== this.form.pol || this.lastFilter.pod !== this.form.pod ||
      //             this.lastFilter.cargoReadyTimeType !== this.form.cargoReadyTimeType ||
      //             this.lastFilter.cargoReadyTimeDate !== this.form.cargoReadyTimeDate ||
      //             this.lastFilter.carrierId !== this.form.carrierId ||
      //             this.lastFilter.directTransit !== this.form.directTransit) {
      //           console.log('6666')
      //
      //           priceTypes.push(SystemConstants.PRICE_QUOTATION_TYPE_TRUNK_LINE.code)
      //         } else if (this.lastFilter.seaEqTypes && this.lastFilter.seaEqTypes.length > 0) {
      //           if (seaEqTypes.join(',') !== this.lastFilter.seaEqTypes.join(',')) {
      //             priceTypes.push(SystemConstants.PRICE_QUOTATION_TYPE_TRUNK_LINE.code)
      //           }
      //         }
      //       }
      //     }
      //   }
      //   if (priceTypes.length > 0) {
      //     const filter = {
      //       page: 1,
      //       limit: 10,
      //       inquiryType: this.type, // 1-整箱 2-拼箱 3-空运
      //       priceTypes
      //     }
      //     this.matchPrice(filter)
      //   }
      // }
    },

    matchPriceClick() {
      const priceTypes = []
      const prePortTip = []
      const lastMileTip = []
      const trunkLineTip = []
      // 港前
      if (this.form.prePortEnable) {
        // 必须存在的字段
        if (!this.form.province) {
          prePortTip.push(this.$t('CargoMsg.Cargo_Province'))
        }
        if (!this.form.pol) {
          prePortTip.push(this.$t('CargoMsg.Cargo_POL'))
        }
        if (this.form.cargoReadyTimeType === SystemConstants.CARGO_READY_TIME_TYPE_RANGE.code && !this.form.cargoReadyTimeRange) {
          prePortTip.push(this.$t('CargoMsg.Cargo_Range'))
        }
        if ((this.form.cargoReadyTimeType === SystemConstants.CARGO_READY_TIME_TYPE_DATE.code && !this.form.cargoReadyTimeDate)) {
          prePortTip.push(this.$t('CargoMsg.Cargo_Date'))
        }
        priceTypes.push(SystemConstants.PRICE_QUOTATION_TYPE_PRE_PORT.code)
      }
      // 尾程
      if (this.form.lastMileEnable) {
        if (!this.form.pod) {
          lastMileTip.push(this.$t('CargoMsg.Cargo_PortOfDischarge'))
        }
        if (this.form.cargoReadyTimeType === SystemConstants.CARGO_READY_TIME_TYPE_RANGE.code && !this.form.cargoReadyTimeRange) {
          lastMileTip.push(this.$t('CargoMsg.Cargo_Range'))
        }
        if (this.form.cargoReadyTimeType === SystemConstants.CARGO_READY_TIME_TYPE_DATE.code && !this.form.cargoReadyTimeDate) {
          lastMileTip.push(this.$t('CargoMsg.Cargo_Date'))
        }
        if (this.form.deliveryAddressType === SystemConstants.DELIVERY_ADDRESS_TYPE_THIRD_PARTY.code && !this.form.postalCode) {
          lastMileTip.push(this.$t('SeaExport.ZIP'))
        }
        if (this.form.deliveryAddressType !== SystemConstants.DELIVERY_ADDRESS_TYPE_THIRD_PARTY.code && !this.form.warehouseCode) {
          lastMileTip.push(this.$t('CargoMsg.Cargo_WarehouseCode2'))
        }
        priceTypes.push(SystemConstants.PRICE_QUOTATION_TYPE_LAST_MILE.code)
      }
      // 干线
      if (this.form.trunkLineEnable) {
        if ([SystemConstants.PRICE_INQUIRY_TYPE_SEA_FCL.code, SystemConstants.PRICE_INQUIRY_TYPE_SEA_LCL.code].indexOf(this.type) > -1) {
          if (!this.form.pol) {
            trunkLineTip.push(this.$t('CargoMsg.Cargo_POL'))
          }
          if (!this.form.pod) {
            trunkLineTip.push(this.$t('CargoMsg.Cargo_PortOfDischarge'))
          }
          if (this.form.cargoReadyTimeType === SystemConstants.CARGO_READY_TIME_TYPE_RANGE.code && !this.form.cargoReadyTimeRange) {
            trunkLineTip.push(this.$t('CargoMsg.Cargo_Range'))
          }
          if (this.form.cargoReadyTimeType === SystemConstants.CARGO_READY_TIME_TYPE_DATE.code && !this.form.cargoReadyTimeDate) {
            trunkLineTip.push(this.$t('CargoMsg.Cargo_Date'))
          }
        }
        if (this.type === SystemConstants.PRICE_INQUIRY_TYPE_SEA_FCL.code) {
          const row = this.form.seaEqList.find(p => !p.type)
          if (row) {
            trunkLineTip.push(this.$t('CargoMsg.Cargo_ContainerSize'))
          }
        }
        priceTypes.push(SystemConstants.PRICE_QUOTATION_TYPE_TRUNK_LINE.code)
      }
      const tips = []
      if (prePortTip.length > 0) {
        tips.push(this.$t('CargoMsg.Cargo_CannotMatchPleaseFill', [this.$t('CargoMsg.Cargo_PrePortRate'), prePortTip.join('、')]))
      }
      if (lastMileTip.length > 0) {
        tips.push(this.$t('CargoMsg.Cargo_CannotMatchPleaseFill', [this.$t('CargoMsg.Cargo_EndRouteRate'), lastMileTip.join('、')]))
      }
      if (trunkLineTip.length > 0) {
        tips.push(this.$t('CargoMsg.Cargo_CannotMatchPleaseFill', [this.$t('CargoMsg.Cargo_MainlineRate'), trunkLineTip.join('、')]))
      }
      if (tips.length > 0) {
        this.$message.warning(tips.join('，'))
        return
      }
      if (priceTypes.length > 0) {
        const filter = {
          page: 1,
          limit: 10,
          inquiryType: this.type, // 1-整箱 2-拼箱 3-空运
          priceTypes
        }
        this.filter = filter
        // 1-整箱 2-拼箱 3-空运
        filter.inquiryType = this.type
        if (this.type === SystemConstants.PRICE_INQUIRY_TYPE_SEA_FCL.code && this.form.seaEqList && this.form.seaEqList.length > 0) {
          filter.seaEqTypes = this.form.seaEqList.filter(p => !!p.type).map(p => p.type).sort()
        } else {
          filter.seaEqTypes = []
        }
        filter.pol = this.form.pol
        filter.pod = this.form.pod
        filter.cargoReadyTimeType = this.form.cargoReadyTimeType
        filter.cargoReadyTimeRange = this.form.cargoReadyTimeRange
        filter.cargoReadyTimeDate = this.form.cargoReadyTimeDate
        filter.carrierId = this.form.carrierId
        filter.directTransit = this.form.directTransit
        filter.province = this.form.province
        filter.city = this.form.city
        filter.districts = this.form.districts
        filter.townUuid = this.form.townUuid
        filter.deliveryAddressType = this.form.deliveryAddressType
        filter.postalCode = this.form.postalCode
        filter.warehouseCode = this.form.warehouseCode
        // this.lastFilter = deepClone(filter)
        this.doMatchPrice(filter)
      }
    },

    setForm(form) {
      this.form = form
      this.convertSeaEq() // 先转换一下箱型箱量
    },

    cancel() {
      if (!this.form.uuid) {
        this.$emit('cancel')
      }
      this.setForm(this.originForm)
      this.isEdit = false
    },

    edit() {
      this.setForm(deepClone(this.originForm))
      this.isEdit = true
    },

    // 保存
    save() {
      if (!this.form.trunkLineEnable && !this.form.prePortEnable && !this.form.lastMileEnable) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PriceType'))
        return
      }
      if ((this.form.cargoReadyTimeType === SystemConstants.CARGO_READY_TIME_TYPE_RANGE.code && !this.form.cargoReadyTimeRange) ||
          (this.form.cargoReadyTimeType === SystemConstants.CARGO_READY_TIME_TYPE_DATE.code && !this.form.cargoReadyTimeDate)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('SeaExport.CargoReadyDate'))
        return
      }
      if (this.form.directTransit && this.form.directTransit === SystemConstants.DIRECT_TRANSIT_TRANSIT.code && !this.form.transferPortCode) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('SeaExport.TransitPort'))
        return
      }
      if (!this.form.palletNature) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_ShipmentOrder'))
        return
      }
      if (!this.form.commerceCode) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_Airline'))
        return
      }
      if (!this.form.pol) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_POL'))
        return
      }
      if (!this.form.pod) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_PortOfDischarge'))
        return
      }
      if (!this.form.cargoType) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('SeaExport.CargoType'))
        return
      }
      if (this.form.cargoType === ImportConstants.CARGOTYPE_DANGEROUS.code) {
        if (!this.form.dangerousGoodsLevel) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('SeaExport.DangerousClass'))
          return
        }
        if (!this.form.unNo) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + 'UN NO')
          return
        }
      }
      if (this.form.cargoType === ImportConstants.CARGOTYPE_OOG.code) {
        if (!this.form.length) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + this.$t('Warehouse.boxLengthPlaceholder'))
          return
        }
        if (!this.form.width) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + this.$t('Warehouse.boxWidthPlaceholder'))
          return
        }
        if (!this.form.height) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + this.$t('Warehouse.BoxHeightPlaceholder'))
          return
        }
      }
      if (this.form.cargoType === ImportConstants.CARGOTYPE_FROZEN.code) {
        if (!this.form.temperature) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + this.$t('SeaExport.Temperature'))
          return
        }
        if (!this.form.ventilationQuantity) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + this.$t('SeaExport.VentilationQuantity'))
          return
        }
      }

      if (this.form.prePortEnable) {
        // 省 必填
        if (!this.form.province) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_Province'))
          return
        }
      }

      if (this.form.lastMileEnable) {
        // 邮编 必填
        if (this.form.deliveryAddressType === SystemConstants.DELIVERY_ADDRESS_TYPE_THIRD_PARTY.code && !this.form.postalCode) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('SeaExport.ZIP'))
          return
        }
        if (this.form.deliveryAddressType !== SystemConstants.DELIVERY_ADDRESS_TYPE_THIRD_PARTY.code && !this.form.warehouseCode) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_WarehouseCode2'))
          return false
        }
      }

      if (this.type === SystemConstants.PRICE_INQUIRY_TYPE_SEA_FCL.code) {
        // 箱型箱量 校验
        const row = this.form.seaEqList.find(p => !p.type || !p.quantity)
        if (row) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_CartonQuantity'))
          return
        }
        if (!this.form.weight) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + this.$t('CargoMsg.Cargo_Weight'))
          return
        }
      } else if (this.type === SystemConstants.PRICE_INQUIRY_TYPE_SEA_LCL.code) {
        if (!this.form.weight) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + this.$t('CargoMsg.Cargo_Weight'))
          return
        }
        if (!this.form.cubage) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + this.$t('CargoMsg.Cargo_Cubage'))
          return
        }
      }
      if (this.type === SystemConstants.PRICE_INQUIRY_TYPE_SEA_FCL.code) {
        const uniqueSet = new Set()
        for (let i = 0; i < this.form.seaEqList.length; i++) {
          const seaEq = this.form.seaEqList[i]
          if (uniqueSet.has(seaEq.type)) {
            this.$message.warning(this.$t('CargoMsg.Cargo_BoxTypeNotAllowedDuplicate'))
            return
          } else {
            uniqueSet.add(seaEq.type)
          }
        }
        const seaEq = []
        this.form.seaEqList.forEach(p => {
          seaEq.push(p.quantity + '*' + p.type)
        })
        this.form.seaEq = seaEq.join(',')
      }
      this.loading = getLoading4Cxt()
      this.form.type = this.type
      this.form.branchId = this.$store.getters.currentOfficeId
      saveInquiryPrice(this.form).then(res => {
        this.setForm(res.data)
        this.originForm = res.data
        this.isEdit = false
        this.$message.success(this.$t('Message.SaveSuccessfully'))
      }).finally(() => {
        this.loading.close()
      })
    },

    // 提交 步骤一，匹配航线负责人
    submitStep1() {
      if ((this.form.trunkLineEnable && !this.selectedTrunkLineData) ||
          (this.form.prePortEnable && !this.selectedPrePortData) ||
          (this.form.lastMileEnable && !this.selectedLastMileData)) {
        this.loading = getLoading4Cxt()
        matchResponsiblePerson({ pol: this.form.pol, commerceCode: this.form.commerceCode }).then(res => {
          const noMatchPerson = []
          if (this.form.trunkLineEnable && !this.selectedTrunkLineData) {
            if (!res.data.trunkLinePersonData || res.data.trunkLinePersonData.length === 0) {
              noMatchPerson.push(this.$t('CargoMsg.Cargo_Mainline_Rate_Leader'))
            }
            this.inquiryResponsiblePersonDialog.trunkLinePersonData = res.data.trunkLinePersonData || []
            if (this.inquiryResponsiblePersonDialog.trunkLinePersonData && this.inquiryResponsiblePersonDialog.trunkLinePersonData.length === 1) {
              this.inquiryResponsiblePersonDialog.trunkLinePersonData[0].selected = true
            }
          }
          if (this.form.prePortEnable && !this.selectedPrePortData) {
            if (!res.data.prePortPersonData || res.data.prePortPersonData.length === 0) {
              noMatchPerson.push(this.$t('CargoMsg.Cargo_Pre_Port_Rate_Leader'))
            }
            this.inquiryResponsiblePersonDialog.prePortPersonData = res.data.prePortPersonData || []
            if (this.inquiryResponsiblePersonDialog.prePortPersonData && this.inquiryResponsiblePersonDialog.prePortPersonData.length === 1) {
              this.inquiryResponsiblePersonDialog.prePortPersonData[0].selected = true
            }
          }
          if (this.form.lastMileEnable && !this.selectedLastMileData) {
            if (!res.data.lastMilePersonData || res.data.lastMilePersonData.length === 0) {
              noMatchPerson.push(this.$t('CargoMsg.Cargo_End_Route_Rate_Leader'))
            }
            this.inquiryResponsiblePersonDialog.lastMilePersonData = res.data.lastMilePersonData || []
            if (this.inquiryResponsiblePersonDialog.lastMilePersonData && this.inquiryResponsiblePersonDialog.lastMilePersonData.length === 1) {
              this.inquiryResponsiblePersonDialog.lastMilePersonData[0].selected = true
            }
          }
          if (noMatchPerson.length > 0) {
            this.$message.warning(this.$t('CargoMsg.Cargo_NoMatchFound', [noMatchPerson.join(',')]))
            return
          }
          this.inquiryResponsiblePersonDialog.visible = true
          return
        }).finally(() => {
          this.loading.close()
        })
      } else {
        // 勾选了【干线/港前/尾程价格】且都选中了【干线/港前/尾程运价】，跳过 匹配航线负责人
        this.submitStep2({
          trunkLinePersonUserIds: this.form.trunkLineEnable ? [Number(this.selectedTrunkLineData.createdBy)] : [],
          prePortPersonUserIds: this.form.prePortEnable ? [Number(this.selectedPrePortData.createdBy)] : [],
          lastMilePersonUserIds: this.form.lastMileEnable ? [Number(this.selectedLastMileData.createdBy)] : [],
          // legacy single value (backward compatible)
          trunkLinePersonUserId: this.form.trunkLineEnable ? Number(this.selectedTrunkLineData.createdBy) : 0,
          prePortPersonUserId: this.form.prePortEnable ? Number(this.selectedPrePortData.createdBy) : 0,
          lastMilePersonUserId: this.form.lastMileEnable ? Number(this.selectedLastMileData.createdBy) : 0
        })
      }
    },

    // 提交 步骤二，提交
    submitStep2(params) {
      const getListSeparator = () => (this.$i18n && this.$i18n.locale === 'zh' ? '、' : ', ')
      // 优先取 选中的运价的创建人
      const normalizeUserIds = (userIds, userId) => {
        const list = Array.isArray(userIds) ? userIds : (userIds ? [userIds] : [])
        if (list.length === 0 && userId) {
          list.push(userId)
        }
        return [...new Set(list.map(p => Number(p)).filter(p => p > 0))]
      }

      params.trunkLinePersonUserIds = normalizeUserIds(params.trunkLinePersonUserIds, params.trunkLinePersonUserId)
      params.prePortPersonUserIds = normalizeUserIds(params.prePortPersonUserIds, params.prePortPersonUserId)
      params.lastMilePersonUserIds = normalizeUserIds(params.lastMilePersonUserIds, params.lastMilePersonUserId)

      if (this.form.trunkLineEnable && this.selectedTrunkLineData) {
        const createdBy = Number(this.selectedTrunkLineData.createdBy)
        params.trunkLinePersonUserIds = createdBy > 0 ? [createdBy] : []
        params.trunkLinePersonUserId = createdBy > 0 ? createdBy : 0
        params.trunkLinePriceUuid = this.selectedTrunkLineData.uuid
      }
      if (this.form.prePortEnable && this.selectedPrePortData) {
        const createdBy = Number(this.selectedPrePortData.createdBy)
        params.prePortPersonUserIds = createdBy > 0 ? [createdBy] : []
        params.prePortPersonUserId = createdBy > 0 ? createdBy : 0
        params.prePortPriceUuid = this.selectedPrePortData.uuid
      }
      if (this.form.lastMileEnable && this.selectedLastMileData) {
        const createdBy = Number(this.selectedLastMileData.createdBy)
        params.lastMilePersonUserIds = createdBy > 0 ? [createdBy] : []
        params.lastMilePersonUserId = createdBy > 0 ? createdBy : 0
        params.lastMilePriceUuid = this.selectedLastMileData.uuid
      }
      // legacy single value (backward compatible)
      params.trunkLinePersonUserId = params.trunkLinePersonUserIds[0] || 0
      params.prePortPersonUserId = params.prePortPersonUserIds[0] || 0
      params.lastMilePersonUserId = params.lastMilePersonUserIds[0] || 0

      // safety check (dialog should already guarantee this)
      const missing = []
      if (this.form.trunkLineEnable && params.trunkLinePersonUserIds.length === 0) missing.push(this.$t('CargoMsg.Cargo_TrunkLine'))
      if (this.form.prePortEnable && params.prePortPersonUserIds.length === 0) missing.push(this.$t('CargoMsg.Cargo_PrePort'))
      if (this.form.lastMileEnable && params.lastMilePersonUserIds.length === 0) missing.push(this.$t('CargoMsg.Cargo_FinalMile'))
      if (missing.length > 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_Inquiry_MissingBusinessCannotSubmit', [missing.join(getListSeparator())]))
        return
      }

      params.uuid = this.form.uuid
      params.trunkLineEnable = this.form.trunkLineEnable
      params.prePortEnable = this.form.prePortEnable
      params.lastMileEnable = this.form.lastMileEnable
      this.loading = getLoading4Cxt()
      submitInquiryPrice(params).then(res => {
        this.selectedTrunkLineData = null
        this.selectedPrePortData = null
        this.selectedLastMileData = null
        this.setForm(res.data)
        this.originForm = res.data
        this.inquiryResponsiblePersonDialog.visible = false
        this.detail()
        this.$message.success(this.$t('CargoMsg.Cargo_OperationComplete'))
      }).finally(() => {
        this.loading.close()
      })
    },

    addSeaEq() {
      if (!this.isEdit) {
        return
      }

      if (this.form.seaEqList.length === 5) {
        return
      }
      this.form.seaEqList.push({
        type: null,
        quantity: 1
      })
    },

    deleteSeaEq(index) {
      if (!this.isEdit) {
        return
      }
      if (this.form.seaEqList.length === 1) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseMaintainAtLeastOne') + this.$t('CargoMsg.Cargo_CartonQuantity'))
        return
      }
      this.form.seaEqList.splice(index, 1)
    },

    podChange(p) {
      this.form.pod = p.value
      if ([SystemConstants.PRICE_INQUIRY_TYPE_SEA_FCL.code, SystemConstants.PRICE_INQUIRY_TYPE_SEA_LCL.code].indexOf(this.type) > -1) {
        this.form.commerceCode = JobUtils.getLineByPort(this.form.pod, SystemConstants.PORT_TYPE_SEAPORT.code)
      } else if (SystemConstants.PRICE_INQUIRY_TYPE_AIR.code === this.type) {
        this.form.commerceCode = JobUtils.getLineByPort(this.form.pod, SystemConstants.PORT_TYPE_AIRPORT.code)
      }
    },

    radioClickHandler(row, quotationType) {
      if (SystemConstants.PRICE_QUOTATION_TYPE_PRE_PORT.code === quotationType) {
        this.selectedPrePortData = row.selected ? row : null
      }
      if (SystemConstants.PRICE_QUOTATION_TYPE_LAST_MILE.code === quotationType) {
        this.selectedLastMileData = row.selected ? row : null
      }
      if (SystemConstants.PRICE_QUOTATION_TYPE_TRUNK_LINE.code === quotationType) {
        this.selectedTrunkLineData = row.selected ? row : null
      }
    },

    async remoteBooking() {
      const inquiryHp = new InquiryHp(this)
      inquiryHp.remoteBooking(this)
      // this.innerVisible = false
    },
    postCodeChange(post) {
      if (post) {
        this.form.postalCode = post.uuid
        this.form.address = post.city
      } else {
        this.form.postalCode = ''
        this.form.address = ''
      }
    },
    deliveryAddressTypeChange() {
      this.form.postalCode = ''
      this.form.address = ''
      this.form.warehouseCode = ''
    },
    prePortEnableChange() {
      if (!this.form.prePortEnable) {
        this.form.province = ''
        this.form.city = ''
        this.form.districts = ''
        this.form.townUuid = ''
        // 清空 表格中的数据
        this.prePortData = []
        this.selectedPrePortData = null
      }
    },
    lastMileEnableChange() {
      if (!this.form.lastMileEnable) {
        this.form.postalCode = ''
        this.form.address = ''
        this.form.warehouseCode = ''
        // 清空 表格中的数据
        this.lastMileData = []
        this.selectedLastMileData = null
      }
    },
    trunkLineEnableChange() {
      if (!this.form.lastMileEnable) {
        // 清空 表格中的数据
        this.trunkLineData = []
        this.selectedTrunkLineData = null
      }
    },
    cargoReadyTimeTypeChange() {
      this.form.cargoReadyTimeRange = 0
      this.form.cargoReadyTimeDate = null
    },
    cargoTypeChange(p) {
      if (this.form.cargoType === ImportConstants.CARGOTYPE_DANGEROUS.code) {
        this.form.dangerousGoodsLevel = 0
        this.form.unNo = 0
      } else if (this.form.cargoType === ImportConstants.CARGOTYPE_OOG.code) {
        this.form.length = 0.0
        this.form.width = 0.0
        this.form.height = 0.0
      } else if (this.form.cargoType === ImportConstants.CARGOTYPE_FROZEN.code) {
        this.form.temperature = 0.0
        this.form.ventilationQuantity = 0.0
      }
      this.form.cargoType = p.value
    }
  }
}
